<template>
  <c_money
    :key="outputValue"
    :value="outputValue"
    :size="props.size"
    :prefix="props.prefix"
    :suffix="props.suffix"
    :format="props.format"
    :color="props.color"
    :bold="props.bold"
  />
</template>

<script>
import { onMounted, reactive, ref, watch, h } from "vue";
import { useTransition } from "@vueuse/core";
import { toDecimal } from "@/utils/funcs";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    duration:{
      type: Number,
      default: 500,
    },
    size: {
      type: Number,
      default: 14,
    },
    prefix: {
      //是否带前缀“￥”
      type: Boolean,
      default: true,
    },
    suffix: Boolean, //是否带后缀“元”
    format: {
      //金额是否需要格式化
      type: Boolean,
      default: true,
    },
    color: {
      //字体颜色
      type: String,
      default: "#f00",
    },
    bold: {
      //是否加粗
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const source = ref(0);
    const state = reactive({});
    let outputValue = useTransition(source, {
      duration: props.duration,
      easing: "ease-out", // 缓动函数
    });
    onMounted(() => {
      if (props.value) source.value = toDecimal(props.value).toNumber();
    });

    return { state, props, outputValue };
  },
};
</script>
<style scoped></style>
